import { SphereTooltipIcon } from "@components/common/sphere-tooltip-icon";
import { InfoIcon, neutral } from "@flat-ui";
import { EDecimalToHex } from "@styles/common-colors";
import { addTransparency } from "@utils/ui-utils";

/** Size for the help icon that activates the tooltip */
const INFO_ICON_SIZE = "16px";

interface Props {
  /** Component that will show when icon is hovered */
  text: React.ReactNode;
}

/** Renders an info icon that shows a tooltip text when hovered */
export function PageSectionInfoIcon({ text }: Props): JSX.Element {
  return (
    <SphereTooltipIcon
      text={text}
      icon={InfoIcon}
      size={INFO_ICON_SIZE}
      tooltipProps={{
        slotProps: {
          tooltip: {
            sx: {
              backgroundColor: neutral[0],
              border: `1px solid ${neutral[200]}`,
              borderRadius: "4px",
              boxShadow: `0px 3px 3px 0px ${addTransparency({
                color: neutral[500],
                alpha: EDecimalToHex.fiftyOne,
              })}`,
              padding: "16px",
            },
          },
        },
      }}
    />
  );
}
